module.exports = __webpack_public_path__ + "img/client-7.288884b3.png";